import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { BsCheck } from 'react-icons/bs';

var WaitlistButton = function WaitlistButton(props) {
  var className = props.className,
      _props$confirmation = props.confirmation,
      confirmation = _props$confirmation === void 0 ? state.waitlist.confirmation : _props$confirmation,
      _props$ctaClick = props.ctaClick,
      ctaClick = _props$ctaClick === void 0 ? function () {} : _props$ctaClick,
      href = props.href,
      waitlistId = props.waitlistId,
      storeId = props.storeId,
      waitlistStoreId = props.waitlistStoreId,
      children = props.children,
      style = props.style;
  var storeid = storeId ? storeId : waitlistStoreId;
  var label = storeid === waitlistId && confirmation ? 'On Waitlist' : 'Join Waitlist';
  var active = storeid === waitlistId && confirmation ? true : false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: function onClick(e) {
      return ctaClick();
    },
    id: "banner-joinwaitlist",
    className: "\n        ".concat(className, "\n        ").concat(active ? 'cb-button-secondary' : 'cb-button-primary', "\n        "),
    href: href,
    style: style
  }, active && /*#__PURE__*/React.createElement("span", {
    className: "pr-1"
  }, /*#__PURE__*/React.createElement(BsCheck, {
    className: "fa-3x"
  })), label, !active && children && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", children)));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    confirmation: state.waitlist.confirmation,
    waitlistId: state.location.waitlistId,
    waitlistStoreId: state.waitlist.storeId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WaitlistButton);